// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"11b05086b668907d","1836":"7abca53a57d0c43f","5735":"beb578cc985d134d"}[chunkId] + ".css";
};